import * as Sentry from '@sentry/react';
import { CaptureConsole } from '@sentry/integrations';
import { Integrations as TracingIntegrations } from '@sentry/tracing';
import { browserHistory } from 'browser-history';
import {
  isSentryEnabled,
  shouldIgnoreBreakCrumbs,
  samplingContext,
  tracingOrigins,
  modifyTransactionNameIfRequired
} from './utils/sentry';
import config from './config';

if (isSentryEnabled()) {
  Sentry.init({
    dsn: config.sentryDsn,
    release: `time-intelligence-web@${process.env.REACT_APP_VERSION}`,
    environment: process.env.REACT_APP_ENVIRONMENT || 'dev',
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'No collector found with id',
      'Collector is already installed',
      'TestingLibraryElementError '
    ],
    integrations: [
      new CaptureConsole({
        levels: ['error']
      }) as any,
      new TracingIntegrations.BrowserTracing({
        tracingOrigins: tracingOrigins(),
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(
          browserHistory
        ),
        beforeNavigate: (context) =>
          modifyTransactionNameIfRequired(context, window.location.href)
      })
    ],
    tracesSampler: samplingContext,
    beforeBreadcrumb(breadcrumb) {
      return shouldIgnoreBreakCrumbs(
        breadcrumb,
        process.env.NODE_ENV === 'production'
      )
        ? null
        : breadcrumb;
    },
    beforeSend: (event: Sentry.Event) => {
      if (
        event.message?.includes('Failed to fetch') &&
        event.breadcrumbs?.some(
          (bc) => bc.type === 'network' && bc.category === 'offline'
        )
      ) {
        return null;
      }

      if (window.navigator.userAgent.includes('HeadlessChrome')) {
        return null;
      }
      return event;
    }
  });
}
